import React from "react";
import { Link } from "react-router-dom";
import { LAWYER_BASE } from "@lawyer/constants/route";

// Lawyers open the room under their own app scope so the lawyer session (and
// X-Advoset-App header) is used — the user-app Header/bell would 401 there.
export function LawyerRoomBar() {
  return (
    <header className="box-border flex w-full max-w-full min-w-0 flex-wrap items-center justify-between gap-x-3 gap-y-2 bg-[#0A2540] px-4 py-3 text-white" data-testid="lawyer-room-bar">
      <Link to={`${LAWYER_BASE}/consultations`} className="inline-flex max-w-full shrink-0 items-center gap-2 font-bold" style={{ fontFamily: "Poppins" }}>
        <span className="h-8 w-8 rounded-lg bg-[#D4AF37] grid place-items-center text-[#0A2540] font-extrabold">A</span> Advoset Lawyer
      </Link>
      <Link to={`${LAWYER_BASE}/consultations`} className="max-w-full break-words text-[11px] font-bold text-[#D4AF37] hover:underline sm:text-xs" data-testid="lawyer-room-back">Back to consultations</Link>
    </header>
  );
}
